import is from '@sindresorhus/is';
import { useContext } from 'react';

import { ApplicationContext } from '../../../../../../shared/source/context/context';

import type { GridPaginationModel } from '@mui/x-data-grid-pro';

export const useTablePagination = (): {
    readonly paginationModel: GridPaginationModel;
    readonly resetPaginationModel: () => void;
    readonly setPaginationModel: (paginationModel: GridPaginationModel) => void;
} => {
    const {
        actions,
        applicationState: { locationSearchParams },
    } = useContext(ApplicationContext);

    const pageSize = is.numericString(locationSearchParams.get('pageSize'))
        ? Number(locationSearchParams.get('pageSize'))
        : 20;

    const page = is.numericString(locationSearchParams.get('page')) ? Number(locationSearchParams.get('page')) : 0;

    const setPaginationModel = (paginationModel: GridPaginationModel): void => {
        locationSearchParams.set('page', paginationModel.page.toString());
        locationSearchParams.set('pageSize', paginationModel.pageSize.toString());

        actions.setLocationSearchParams(locationSearchParams);
    };

    const resetPaginationModel = (): void => {
        locationSearchParams.delete('page');
        locationSearchParams.delete('pageSize');

        actions.setLocationSearchParams(locationSearchParams);
    };

    return {
        paginationModel: {
            page,
            pageSize,
        },
        resetPaginationModel,
        setPaginationModel,
    };
};
